import { useState } from "react";
import ButtonAddNew from "src/components/atoms/button-add-new/button-add-new";
import Banner from "src/components/molecules/banner/Banner";
import CreateReseller from "./create-reseller";

export enum FormMode {
	List,
	New,
	Edit,
}

const ResellerList = () => {
	const [mode, setMode] = useState<FormMode>(FormMode.List);
	const [selectedReseller, setSelectedReseller] = useState<string | null>(
		null
	);

	const handleAddNew = () => {
		setMode(FormMode.New);
	};

	const handleEdit = (resellerId: string) => {
		setSelectedReseller(resellerId);
		setMode(FormMode.Edit);
	};

	const handleBackToList = () => {
		setMode(FormMode.List);
		setSelectedReseller(null);
	};

	return (
		<>
			<Banner label={"Resellers"}>
				<div className="bg-white p-6 rounded-lg drop-shadow-2xl w-full">
					<div className="flex flex-col items-start justify-center gap-12 w-full">
						{/* Add New Button */}
						{mode === FormMode.List && (
							<div className="flex items-center justify-end gap-4 w-full">
								{/* place your list here */}
								<ButtonAddNew onClick={handleAddNew} />
							</div>
						)}

						{/* Render Components Based on FormMode */}

						{mode === FormMode.New && (
							<CreateReseller></CreateReseller>
						)}

						{mode === FormMode.Edit && selectedReseller && (
							<CreateReseller />
						)}
					</div>
				</div>
			</Banner>
		</>
	);
};

export default ResellerList;
